export const SET_PLACE = "SET_PLACE"
export const SET_ACTIVE_DEVICE = "SET_ACTIVE_DEVICE"